module.exports = __webpack_public_path__ + "img/euFlagBG.3c52af56.png";